export default "__VITE_ASSET__3f7cb6ca__"